export const SEARCH_BY_TEXT = 'filters/searchByText';
export const SEARCH_BY_AUTHOR_NAME = 'filters/serachByAuthorName';
export const SEARCH_BY_CATEGORY = 'filters/serachByCategory';
export const CLEAR_FILTER = 'filters/clearFilter';